module.exports = __webpack_public_path__ + "img/logo-appstore.bbda21f4.png";